import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const bonos = [{
  num: 1,
  title: 'CATÁLOGO EXPRESS LISTO PARA VENDER',
  desc: 'Armá tu catálogo en una tarde y empezá a enviarlo por WhatsApp hoy mismo.',
  value: '8.000'
}, {
  num: 2,
  title: '50 MENSAJES CORTOS QUE VENDEN SOLOS',
  desc: 'Frases listas para frascos, Instagram y promociones.',
  value: '10.000'
}, {
  num: 3,
  title: 'RESPUESTAS LISTAS PARA CLIENTES DE WHATSAPP',
  desc: '41 respuestas para copiar y pegar: bienvenida, precios, cierre y objeciones.',
  value: '9.000'
}, {
  num: 4,
  title: 'CHECKLIST DE TU PRIMERA FERIA CRISTIANA',
  desc: 'Todo lo que necesitás para llegar preparada y vender sin improvisar.',
  value: '8.000'
}, {
  num: 5,
  title: '25 IDEAS DE POSTS PARA VENDER SIN QUEDAR PESADA',
  desc: 'Captions listos y calendario semanal para vender con naturalidad.',
  value: '9.000'
}, {
  num: 6,
  title: 'GUÍA DE PRESENTACIÓN PARA REGALOS ESPECIALES',
  desc: '10 técnicas premium para que tus frasquitos se vendan a mejor precio.',
  value: '9.000'
}];
export function BonosSection() {
  return <section className="py-20 px-4 bg-brand-base border-t border-white/5 pt-[8px] pb-[8px]" data-id="element-16">
      <div className="max-w-5xl mx-auto border-2 border-dashed border-brand-orange/40 rounded-3xl p-6 sm:p-12 bg-brand-deepInk/60 relative" data-id="element-17">
        <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-brand-orange text-white px-6 py-2 rounded-full font-bold shadow-lg flex items-center gap-2" data-id="element-18">
          <span data-id="element-19">🎁</span> 6 BONOS ESTRATÉGICOS
        </div>

        <div className="mb-12 mt-6" data-id="element-20">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-white mb-2" data-id="element-21">
            SIEMPRE INCLUIDOS — SIN COSTO ADICIONAL
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-22">
          {bonos.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="bg-white/5 backdrop-blur-sm p-6 rounded-2xl border border-white/10 flex flex-col items-center h-full" data-id="element-23">
              <div className="bg-brand-orange text-white text-xs font-bold px-3 py-1 rounded-md mb-4" data-id="element-24">
                BONO 0{bono.num}
              </div>
              <h3 className="text-lg font-bold text-white mb-3 leading-tight" data-id="element-25">
                {bono.title}
              </h3>
              <p className="text-gray-400 text-sm mb-6 flex-grow leading-relaxed" data-id="element-26">
                {bono.desc}
              </p>

              <div className="bg-black/40 rounded-xl p-4 flex justify-between items-center mt-auto border border-white/5 w-full" data-id="element-27">
                <div className="text-left" data-id="element-28">
                  <p className="text-xs text-gray-500 font-medium" data-id="element-29">
                    Valor real
                  </p>
                  <p className="text-sm text-gray-400 line-through font-bold" data-id="element-30">
                    ${bono.value}
                  </p>
                </div>
                <div className="text-right" data-id="element-31">
                  <p className="text-xs text-gray-500 font-medium" data-id="element-32">Hoy</p>
                  <p className="text-lg text-brand-green font-extrabold" data-id="element-33">
                    GRATIS
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-green rounded-2xl p-6 sm:p-8 text-white shadow-[0_10px_40px_rgba(74,27,109,0.3)] flex flex-col sm:flex-row items-center justify-between gap-6" data-id="element-34">
          <div data-id="element-35">
            <p className="text-white/90 font-medium mb-1" data-id="element-36">
              Valor total de los bonos
            </p>
            <p className="text-3xl font-extrabold line-through opacity-90" data-id="element-37">
              $53.000 ARS
            </p>
          </div>
          <div className="w-px h-16 bg-white/30 hidden sm:block" data-id="element-38"></div>
          <div data-id="element-39">
            <p className="text-white/90 font-medium mb-1" data-id="element-40">Con tu MegaPack</p>
            <p className="text-4xl font-extrabold flex items-center gap-3 justify-center" data-id="element-41">
              <span className="bg-white text-brand-green rounded-full p-1" data-id="element-42">
                <Check size={24} strokeWidth={4} data-id="element-43" />
              </span>
              GRATIS
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}